import { Injectable, Type } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { map, catchError, take, subscribeOn } from 'rxjs/operators';
import { CommonService } from '@advsol/core';
import { PersonData } from 'models/personData';
import { ClientContextService } from './ClientContextService';
import { ITypedPagedResult } from '../models/pagedResult';
import { GenericEntityData } from '../models/genericEntityData';
import { ParseGenericEntityData } from './ParseGenericEntityData';

@Injectable({
    providedIn: 'root'
})
export class UDTableService extends CommonService {

    constructor(private http: HttpClient, private clientContext: ClientContextService, private parseGenericEntityData: ParseGenericEntityData) {
        super(http);
    }

    public FetchSingle<T>(tableName: string, userId:string, type: { new(): T }): Observable<T> {

        var subject = new Subject<T>();

        var path = `api/${tableName}/${userId}`;
        return this.http.get(path)
            .pipe(
            map(res => this.parseGenericEntityData.parseData(res, type)),
            catchError(err => of([]))
            )
            /*.subscribe((x: GenericEntityData) => {

            /*
            var temp = new type();
            //now loop through the properties of each result and add them to the temp Obj.
            x.Properties.$values.forEach(function (proper, index2) {
            temp[proper.Name] = proper.Value;
            });
            */
        /*
            //TODO: there was an error and nothing was returned, need a less sucky way to handle errors
            if (x.EntityTypeName !== undefined) {
                subject.next(this.parseGenericEntityData.parseData(x, type));
            } else {
                subject.next();
            }
        })*/;

        //return subject.asObservable();
    }

    public FetchAllById<T>(tableName: string, userId: string, type: { new(): T }): Observable<T[]> {
        var subject = new Subject<T[]>();
        var path = `api/${tableName}/?ID=${userId}`;

        return this.http.get(path)
            .pipe(
                map(res => this.parseGenericEntityData.parseData(res, type)),
                catchError(err => {
                    return of(new type())
                })
            );
    }

    public PushSingle<T>(tableName: string, userId: string, data: T, type: { new(): T }): Observable<T> {

        var subject = new Subject<T>();

        //build the Generic Entity Data
        var entity = this.parseGenericEntityData.updateSingleGenericEntityData(data, tableName);
        var path = `api/${tableName}/${userId}`;

        return this.http.post(path, entity).pipe(
            map(res => this.parseGenericEntityData.parseData(res, type))
        );
    }

    public PushMulti<T>(tableName: string, userId: string, data: T, type: { new(): T }): Observable<T> {
        var subject = new Subject<T>();

        // Build the Generic Entity Data
        var entity = this.parseGenericEntityData.updateSingleGenericEntityData(data, tableName);
        var path = `api/${tableName}`;

        return this.http.post(path, entity).pipe(
            map(res => this.parseGenericEntityData.parseData(res, type))
        );
    }

    public UpdateSingle<T>(tableName: string, userId: string, data: T, type: { new(): T }): Observable<T> {

        var subject = new Subject<T>();

        //build the Generic Entity Data

        var entity = this.parseGenericEntityData.updateSingleGenericEntityData(data, tableName);
        var path = `api/${tableName}/${userId}`;
        return this.http.put(path, entity).pipe(
            map(res => this.parseGenericEntityData.parseData(res, type))
        );
    }

    public UpdateSingleMultiTable<T>(tableName: string, userId: string, seqn: string, data: T, type: { new(): T }): Observable<T> {

        var subject = new Subject<T>();

        //build the Generic Entity Data

        var entity = this.parseGenericEntityData.updateSingleGenericEntityData(data, tableName);
        var path = `api/${tableName}/~${userId}|${seqn}`;
        return this.http.put(path, entity).pipe(
            map(res => this.parseGenericEntityData.parseData(res, type))
        );
    }

    public DeleteAddMemberListDetail(userId: string, seqn: string): Observable<void> {
        var path = `api/CBA_ADD_MEMBER_LIST_DETAILS/~${userId}|${seqn}`;
        return this.http.delete(path).pipe(
            map(res => { })
        );
    }

    public DeleteEditRequestDetail(userId: string, seqn: string): Observable<void> {
        var path = `api/CBA_EDIT_REQUEST_DETAILS/~${userId}|${seqn}`;
        return this.http.delete(path).pipe(
            map(res => { })
        );
    }



}
